module.exports = __webpack_public_path__ + "img/monitor.e6b22260.svg";